import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const ODButton = styled(Button)(() => ({
  color: "#fff",
  backgroundColor: "#7C0E0E",
  "&:hover": {
    backgroundColor: "#7C0E0E",
  },
  marginLeft: 5,
  textTransform: "none",
  borderRadius: 18,
  fontsize: 12,
  minWidth: 100,
}));

const InputButton = (props) => {
  const { id, type, children, onClick, className, startIcon } = props;
  return (
    <ODButton
      id={id}
      className={className}
      variant="contained"
      type={type}
      onClick={onClick}
      startIcon={startIcon}
      style={
        children === "Edit"
          ? { backgroundColor: "#027E4A", marginTop: 15 }
          : children === "Submit"
          ? { backgroundColor: "#027e4a" }
          : children === "Reset"
          ? { backgroundColor: "#db303f" }
          : {}
      }
    >
      {children}
    </ODButton>
  );
};

export default InputButton;
